import React from 'react'
import PropTypes from 'prop-types'
import { Radio } from '@entrata/portals-common/lib/boxed-fields'
import styled from '@emotion/styled'

const StyledRadio = styled(Radio)`
  ::before {
    background: ${({ theme, checked }) =>
      checked
        ? theme.radio_button.background_blue
        : theme.radio_button.background_default};
    border: 1px solid ${({ theme }) => theme.radio_button.border_color};
    height: 21px;
    width: 21px;
  }
  ::after {
    width: 11px;
    height: 11px;
    background: ${({ theme }) => theme.radio_button.background_light_blue};
  }
`

const RadioButton = React.forwardRef((props, ref) => {
  return <StyledRadio {...props} ref={ref} />
})

RadioButton.propTypes = {
  block: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.any,
  checked: PropTypes.bool.isRequired,
}

export default RadioButton
